import { useParams, Navigate, Link } from "react-router-dom";
import { Football, Basketball, Hockey, GraduationCap, Baseball } from "@phosphor-icons/react";

const META = {
  nfl: {
    name: "NFL", icon: Football, season: "Kicks off September 2026",
    tagline: "Same Pooh Sheet edge. New gridiron.",
    features: ["Anytime TD Predictor", "Funnel Defense Weak Spots", "Prop Board, Parlays & Line Shopping"],
  },
  nba: {
    name: "NBA", icon: Basketball, season: "Tips off October 2026",
    tagline: "Buckets, props and value — the Pooh way.",
    features: ["Points / Threes Prop Predictor", "Pace & Matchup Edges", "Value Board & Parlay Builder"],
  },
  nhl: {
    name: "NHL", icon: Hockey, season: "Puck drops October 2026",
    tagline: "Light the lamp with real edges.",
    features: ["Goal Scorer Predictor", "Goalie Weak Spots", "Value Board & Line Shopping"],
  },
  ncaaf: {
    name: "NCAAF", icon: GraduationCap, season: "Kicks off late August 2026",
    tagline: "Saturdays are about to pay for Sundays.",
    features: ["Spread & Total Edges", "Upset Radar", "Conference Value Boards"],
  },
  ncaab: {
    name: "NCAAB", icon: GraduationCap, season: "Tips off November 2026",
    tagline: "From tip-off to March Madness.",
    features: ["Spread & Total Edges", "Upset Radar", "Bracket & Futures Tools"],
  },
};

export default function ComingSoon() {
  const { sport } = useParams();
  const meta = META[sport];
  if (!meta) return <Navigate to="/dashboard" replace />;
  const Icon = meta.icon;
  return (
    <div className="flex items-center justify-center min-h-[70vh]" data-testid={`coming-soon-${sport}`}>
      <div className="max-w-xl w-full text-center fade-up">
        <div className="relative inline-flex items-center justify-center w-24 h-24 rounded-full card-gold border border-[#a855f7]/40 gold-glow-strong mb-6">
          <Icon size={48} weight="duotone" className="text-[#a855f7]" />
          <span className="absolute -top-1 -right-2 text-[9px] font-black uppercase tracking-widest bg-[#a855f7] text-black px-2 py-0.5 rounded-full rotate-6">Soon</span>
        </div>
        <h1 className="font-display text-5xl sm:text-6xl font-black uppercase tracking-tight">
          {meta.name} <span className="gold-text">Coming Soon</span>
        </h1>
        <div className="font-chalk text-3xl text-white mt-3 -rotate-1">{meta.tagline}</div>
        <span className="inline-block mt-4 text-[11px] uppercase tracking-[0.25em] font-bold text-[#22c55e] bg-[#22c55e]/10 border border-[#22c55e]/40 px-3 py-1.5 rounded-full" data-testid="coming-soon-season">
          {meta.season}
        </span>
        <div className="grid sm:grid-cols-3 gap-2.5 mt-8">
          {meta.features.map((f, i) => (
            <div key={f} className={`card-surface rounded-lg p-3.5 text-xs font-semibold text-neutral-300 fade-up-${i + 1}`} data-testid={`coming-soon-feature-${i}`}>
              {f}
            </div>
          ))}
        </div>
        <p className="text-neutral-500 text-sm mt-6">We're locked in on MLB right now — {meta.name} tools drop before the season starts. Your membership will cover it all.</p>
        <Link to="/dashboard" data-testid="coming-soon-back-btn"
          className="inline-flex items-center gap-2 mt-6 bg-[#a855f7] hover:bg-[#9333ea] text-black font-bold uppercase tracking-wider text-sm px-6 py-3 rounded transition-colors duration-200">
          <Baseball size={16} weight="duotone" /> Back to MLB
        </Link>
      </div>
    </div>
  );
}
